import _Number$isInteger from "@babel/runtime-corejs2/core-js/number/is-integer";
import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
// The whole history management is handled by this lib:
//  https://github.com/ReactTraining/history
// Using the following lib for parsing the query string (with some custom modifications)
//  https://github.com/sindresorhus/query-string
import { createBrowserHistory } from 'history';
import invariant from 'invariant';
import { parseRouteToUrl, parseQueryString } from './url';
import { REDUX_PUSH, REDUX_GO, REDUX_REPLACE } from '../redux/reducer'; // Create history instance

export var history = createBrowserHistory(); // Listen to history and dispatch actions accordingly
// This is imo the better way than the other way round, cause 3rd party +
//  # links etc. wont screw up the router

export var destroyers = [];
/**
 * The listener callback function for history actions
 * It will receive one of the following actions: `PUSH`, `REPLACE`, `POP`
 * and will dispatch redux actions accordingly
 * See also https://github.com/ReactTraining/history#listening
 * @param  {Object} location
 * @param  {String} action
 */

export function historyListener(location, action, _ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState,
      cb = _ref.cb;

  if (cb && typeof callback === 'function') {
    cb(location, action);
  }

  location = normalizeLocation(location);

  switch (action) {
    case 'PUSH':
      dispatch({
        type: REDUX_PUSH,
        payload: location
      });
      break;

    case 'REPLACE':
      dispatch({
        type: REDUX_REPLACE,
        payload: location
      });
      break;

    case 'POP':
      // NOTE: the POP event gets fired for all `go` events, both
      // forwards and backwards ... since the event data doesn't contain
      // the steps we can only pass in the new location key and go from
      // there in the reducer :(
      // For some reason sometimes the history POP event doesn't have the
      // key in the location payload, so we try to figure out the prev
      // history entry ourselves...
      var toKey = location.key;

      if (!toKey) {
        // Try to get key from state
        var currState = getState().whereabouts;
        var currIndex = currState.history.findIndex(function (i) {
          return i === currState.current;
        });

        if (currIndex > 0) {
          var prevLocation = currState.locations[currState.history[currIndex - 1]];

          if (prevLocation && prevLocation.path === location.path) {
            toKey = prevLocation.key;
          }
        }
      }

      dispatch({
        type: REDUX_GO,
        payload: {
          toKey: toKey,
          location: location
        }
      });
      break;
  }
}
/**
 * Initialize history listener
 * @param  {function} dispatch
 */

export function init(dispatch, getState, cb) {
  // We always run `destroy` first, to make sure we don't accidentially register
  // multiple listeners, but we only want to destroy the listener for the store
  // that we are going to init it for ... we use the dispatch functions reference
  // to determine that!
  var d = destroyers.find(function (d) {
    return d.dispatch === dispatch;
  });

  if (d) {
    d.destroy();
  }

  var destroy = history.listen(function (location, action) {
    return historyListener(location, action, {
      dispatch: dispatch,
      getState: getState,
      cb: cb
    });
  });
  destroyers.push({
    dispatch: dispatch,
    destroy: destroy
  }); // We must mark the history state with the initialisation of whereabouts,
  // because a state `key` is required for (backwards) route traversal.
  // NOTE:
  // If the App's frame, and location, is being side-controlled then this
  // setup may break. eg. You could see breakages in Storybook on some browsers

  if (window && window.history) {
    window.history.replaceState({
      key: 'init'
    }, 'whereabouts');
  }
}
/**
 * Normalize the browser location object
 * @param  {Object} historyLocation
 * @return {Object}
 */

export function normalizeLocation(historyLocation) {
  var protocol = historyLocation.protocol,
      hostname = historyLocation.hostname,
      port = historyLocation.port,
      pathname = historyLocation.pathname,
      search = historyLocation.search,
      hash = historyLocation.hash,
      key = historyLocation.key;
  return {
    key: key,
    protocol: protocol ? protocol.substr(0, protocol.length - 1) : undefined,
    port: port,
    // Rename hostname to host
    host: hostname,
    // Rename pathname to path
    path: pathname,
    // Hash is 'null' if no hash is set, '' if hash is used but no characters after
    // the hash and the string (excluding the hash) if a hash string is defined
    //   /something => null
    //   /something# => ''
    //   /something#hello => 'hello'
    hash: !hash || hash === '' ? null : hash.substr(1),
    // Query is the parsed search string
    query: parseQueryString(search, {
      arrayFormat: 'bracket'
    })
  };
}
/**
 * Push new route
 * @param  {Object} route
 * @param  {Object} options
 */

export function push(route) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  invariant(route && route.config, 'Cannot push invalid route object!');
  invariant(route.config.path, 'You need to at least define a path for the new route:\n\t{ config: { path: \'/some/path\' } }');

  var finalRoute = _objectSpread({}, route.config, options);

  var url = parseRouteToUrl(finalRoute);
  history.push(url, options.state);
}
/**
 * Push new route
 * @param  {Object} route
 * @param  {Object} options
 */

export function replace(route) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  invariant(route && route.config, 'Cannot replace current route with invalid route object!');
  invariant(route.config.path, 'You need to at least define a path for the new route:\n\t{ config: { path: \'/some/path\' } }');

  var finalRoute = _objectSpread({}, route.config, options);

  var url = parseRouteToUrl(finalRoute);
  history.replace(url, options.state);
}
/**
 * Push new route
 * @param  {int} steps
 */

export function go(steps) {
  invariant(steps !== undefined, 'Steps cannot be undefined!');
  invariant(_Number$isInteger(steps), 'Steps has to be an integer!');
  invariant(steps !== 0, 'Steps cannot be 0!');
  history.go(steps);
}
/**
 * Same as go(1)
 */

export function goForward() {
  history.goForward();
}
/**
 * Same as go(-1)
 */

export function goBack() {
  history.goBack();
}
/**
 * Alias for goBack()
 */

export var pop = goBack;